// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper__Esjkq","footerButton":"footerButton__He8o3","iframe":"iframe__aRecb","iframeDisplay":"iframeDisplay__MHgdy","loader":"loader__WUdy9"};